export const SHOW_EMAIL_LOGIN = ['DEV', 'QA', 'UAT'].includes(
  process.env.APP_ENVIRONMENT?.trim().toUpperCase() || ''
);
